import { Injectable, inject, NgZone  } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, of, switchMap } from 'rxjs';
import { environment } from '../../enviroments/environment';

declare global {
  interface Window {
    ipqs?: {
      AfterResult?: (callback: (result: any) => void) => void;
      AfterFailure?: (callback: (error: any) => void) => void;
      Init?: () => void;
      Trigger?: (selector: string, callback: (event: Event) => void) => void;
      Pause?: () => void;
      Resume?: () => void;
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class IPQSService {
  private baseUrl = 'https://ipqualityscore.com/api/json';
  private scriptLoaded = false;
  private readonly secretKey = 'bKWZMw9sFq3FmZmaDzhv54Q0Dhi7FIEXEKyHXBNidhMklx8TdK3ISD5IgWppvTiyGzwOKpS8j16tAzwzM1cCoxhaHutAOPjDLD2JkxeditSZnuLTlqrsb8J1vkEjjXGePQmjrUiIHTM5R6rvt3s1Q2vX5TS0lr5hbFmnK6inXwL39u2s8IQQMIruI06IUwnMahK3jaCJKtW2lmdausc6uyjUcE1518x5B2Orkn9McUOExd2E6HVFuSMGAsnwHXmS';

  constructor(
    private http: HttpClient,
    private ngZone: NgZone
  ) { }


  public IPQSInfo$ = new BehaviorSubject<any>(null);
  public IPQSInfo: Observable<any> = this.IPQSInfo$.asObservable();

  getIPQSQualityScore(): Observable<any> {
    return this.getIPAddress().pipe(

      switchMap((ip: string) => {
        if (!ip) {
          throw new Error('No se pudo obtener la dirección IP');
        }
        const url = `${this.baseUrl}/ip/${environment.IPQS.api_key}/${ip}`;
        return this.http.get(url);
      }),
      catchError(error => {
        console.error('Error al obtener calidad IPQS:', error);
        return of(null); 
      })
    );
  }

  private getIPAddress(): Observable<string> {
    return this.http.get<{ ipString: string }>('https://api.bigdatacloud.net/data/client-ip').pipe(
      map(response => {
        return response.ipString
      })
      

    );
  }

  getIPQSInfo():any {
    return this.IPQSInfo$.getValue();
  }  


  initializeDeviceFingerprint(): Observable<any> {
    return new Observable((observer) => {
      // Si el script ya está cargado y window.ipqs existe, iniciamos directamente
      if (this.scriptLoaded && window.ipqs) {
        this.setupCallbacks(observer);
        window.ipqs.Init?.();
      } else {
        // Cargamos el script dinámicamente        
        this.loadScript()
          .then(() => {
            this.setupCallbacks(observer);
            console.log(window)
          })
          .catch((err) => {
            observer.error('Error al cargar el script de IPQS: ' + err);
          });
      }
    });
  }
  private loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.ipqscdn.com/api/*/${this.secretKey}/learn.js`;
      script.async = true;
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = (err) => reject(err);
      document.head.appendChild(script);
    });
  }
  private setupCallbacks(observer: any) {
    console.log("Cargamos el script dinámicamente")
    if (!window.ipqs) {
      observer.error('IPQS no está disponible');
      return;
    }
    

    // Configurar callback de éxito
    window.ipqs.AfterResult = (result: any) => {
      // Devolvemos el control a Angular para que detecte cambios
      this.ngZone.run(() => {
        observer.next(result);
        observer.complete();
      });
    };

    // Configurar callback de error
    window.ipqs.AfterFailure = (error: any) => {
      this.ngZone.run(() => {
        observer.error('Fallo en IPQS: ' + JSON.stringify(error));
      });
    };
  }


}

